export const LANGUAGES = ['uz', 'ru', 'en'] as const

export type Language = (typeof LANGUAGES)[number]

/** Язык, если Telegram не прислал ни одного из поддерживаемых. */
export const DEFAULT_LANGUAGE: Language = 'ru'

/** BCP 47 для `Intl` и атрибута `lang` на `<html>`. */
export const LANGUAGE_LOCALE: Record<Language, string> = {
  uz: 'uz-Latn-UZ',
  ru: 'ru-RU',
  en: 'en-US',
}

/**
 * Название языка — на нём самом, в словари не идёт и не переводится: человек
 * ищет в списке свой язык, а не его перевод на текущий (вдруг текущий ему
 * незнаком). Порядок — `LANGUAGES`.
 */
export const LANGUAGE_NAME: Record<Language, string> = {
  uz: "O'zbekcha",
  ru: 'Русский',
  en: 'English',
}

/** `language_code` из Telegram (`ru`, `uz`, `en-US`…) → поддерживаемый язык или `null`. */
export const toLanguage = (code: string | null | undefined): Language | null => {
  const primary = code?.split('-')[0]?.toLowerCase()

  return LANGUAGES.find((lang) => lang === primary) ?? null
}
